import { Button } from "@/components/ui/button";

const KEYS = [
	["1", "2", "3"],
	["4", "5", "6"],
	["7", "8", "9"],
	["*", "0", "#"],
] as const;

const SUB_LABELS: Record<string, string> = {
	"2": "ABC",
	"3": "DEF",
	"4": "GHI",
	"5": "JKL",
	"6": "MNO",
	"7": "PQRS",
	"8": "TUV",
	"9": "WXYZ",
	"0": "+",
};

interface DialPadProps {
	onDigitPress: (digit: string) => void;
	disabled?: boolean;
}

export function DialPad({ onDigitPress, disabled }: DialPadProps) {
	return (
		<div className="grid grid-cols-3 place-items-center gap-y-2 gap-x-4 py-1">
			{KEYS.flat().map((key) => (
				<Button
					key={key}
					variant="ghost"
					disabled={disabled}
					className="flex size-14 flex-col gap-0 rounded-full bg-muted/50 text-lg font-medium hover:bg-muted active:scale-95 transition-all"
					onClick={() => onDigitPress(key)}
				>
					{key}
					{SUB_LABELS[key] && (
						<span className="text-[8px] font-normal tracking-[0.2em] text-muted-foreground/70 leading-none">
							{SUB_LABELS[key]}
						</span>
					)}
				</Button>
			))}
		</div>
	);
}
